var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{domProps:{"textContent":_vm._s(_vm.prefix)}}),(_vm.realMode === 'wrapper')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}}):_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }